import { PropsWithChildren } from 'react';

import { Content } from 'antd/lib/layout/layout';

import styles from './style.module.less';

export const DefaultLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <Content className={styles.content}>{children}</Content>;
};
